import { pluralizeRu } from '@/common/lib/text'
import { Card } from '@/common/ui/Card'

type BalanceCardProps = {
    tokens: number
    isLoading?: boolean
}

export const BalanceCard = ({ tokens, isLoading }: BalanceCardProps) => {
    const generations = Math.floor(tokens / 48)
    return (
        <Card className='flex-1 relative'>
            {/* <div className='absolute right-5 top-5'>
                <Icon name='info-circle' className='w-6 h-6 text-pixorion-gray-2' />
            </div> */}
            <div className='flex flex-col gap-6'>
                <h3 className='text-lg font-medium'>Баланс</h3>
                <div className='flex items-center gap-4 h-9'>
                    {isLoading ? (
                        <p className='text-[30px] font-bold leading-[1.4] text-pixorion-gray-2'>Загрузка...</p>
                    ) : (
                        <p
                            className='text-[30px] font-bold leading-[1.4]'
                            style={{
                                background: 'linear-gradient(97deg, #C0ACE0 -15.56%, #C535F1 102.37%)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text',
                            }}
                        >
                            {tokens.toLocaleString('ru-RU')} {pluralizeRu(tokens, ['токен', 'токена', 'токенов'])}
                        </p>
                    )}
                </div>
                <div className='flex-1 flex items-end'>
                    <p className='text-sm text-pixorion-gray-2'>
                        {tokens === 0
                            ? 'У вас пока нет доступных токенов'
                            : `Ваших токенов хватает на ${generations} ${pluralizeRu(generations, ['генерация', 'генерации', 'генераций'])}`}
                    </p>
                </div>
            </div>
        </Card>
    )
}
